module.exports = __webpack_public_path__ + "static/img/course06.8332fdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/course06.jpg
// module id = sW8E
// module chunks = 101